module.exports = __webpack_public_path__ + "assets/img/7w.24878e6d.png";